// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__Gh40_","left":"InfoRow_left__3EeTw"};